import { all, call } from 'redux-saga/effects';

import connectWitness from './connectWitness';
import getGodWintesses from './getGodWitnesses';
import registerWitness from './registerWitness';

export function* witnessSagas() {
  yield all([getGodWintesses, registerWitness, connectWitness].map(call));
}
